export default {
  edit: {
    en: 'Edit review',
  },
}
